import { useAppSelector } from 'store/hooks';
import { OrderSelectors } from 'store/Orders';
import { Order } from 'store/Orders/types';

export function useOrderItems<T extends Order | undefined>(
  order: T,
  showHiddenItem?: boolean,
) {
  const allItems = useAppSelector((state) =>
    order?.item_uuids
      ? OrderSelectors.selectItemsByIds(state, order?.item_uuids)
      : undefined,
  );

  const filteredItems = useAppSelector((state) =>
    order?.filtered_items_uuids
      ? OrderSelectors.selectItemsByIds(state, order?.filtered_items_uuids)
      : undefined,
  );

  const items = showHiddenItem ? allItems : filteredItems;

  return {
    items,
    allItems,
    filteredItems,
  };
}
